module.exports = __webpack_public_path__ + "img/prize3.37be7e1b.png";